
<template >
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'70px'}" id="outermost">

        <van-nav-bar
            title="修改用户资料"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
            id="topbar"
        />
        <van-form @submit="onSubmit">
          <div class="topDiv">
              <van-cell-group>
                  <van-field name="avatar" label="头像" input-align="right">
                    <template #input>
                      <img class="headImg" :src="apiUrl + 'download/' + userInfo.avatar"/>
                      <van-uploader v-model="avatar" :max-count="1" :before-delete="beforeDel" :before-read="beforeRead" :after-read="afterRead" />
                    </template>
                  </van-field>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="姓名" required v-model="userInfo.nname" input-align="right" :rules="[{ required: true, message: '请输入姓名'}]"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field name="radio" required label="性别" input-align="right" :rules="[{ required: true, message: '请选择性别'}]">
                    <template #input>
                      <van-radio-group v-model="userInfo.ssex" direction="horizontal">
                        <van-radio name="0">男</van-radio>
                        <van-radio name="1">女</van-radio>
                        <van-radio name="2">保密</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="手机号" required v-model="userInfo.mobile" input-align="right" :rules="[{ required: true, message: '请输入手机号'}]"/>
              </van-cell-group>
              <van-cell-group>
                  <van-field label="邮箱" required v-model="userInfo.email" input-align="right" :rules="[{ required: true, message: '请输入邮箱'}]"/>
              </van-cell-group>
          </div>
          <div style="position: fixed;bottom: 0px;width: 100%;">
              <van-button block color="#1B75F6" native-type="submit">完成提交</van-button>
          </div>
        </van-form>
  </div>
</template>

<script>
    import Vue from 'vue';
    import $ from '@/fly'
    import { Toast, Uploader, Dialog } from 'vant';
    import uploadfilecommon from '@/libs/uploadfilecommon';
    import Setting from '@/setting';

    Vue.use(Uploader);
    export default {
        name: 'common-modifyUserInfo',
        data () {
            return {
                clientHeight: window.screen.height,
                userInfo: {},
                avatar: [],
                apiUrl: Setting.apiBaseURL
            }
        },

        methods: {
            onSubmit () {
              this.userInfo.createTime = new Date()
              this.userInfo.modifyTime = new Date()
              this.userInfo.lastLoginTime = new Date()
                $.put('user/mobile/updateUser', this.userInfo).then(res => {
                    Toast.success('修改成功！');
                    this.$store.state.admin.user.info.nname = this.userInfo.nname;
                    this.$store.state.admin.user.info.ssex = this.userInfo.ssex;
                    this.$store.state.admin.user.info.mobile = this.userInfo.mobile;
                    this.$store.state.admin.user.info.email = this.userInfo.email;
                    this.$store.state.admin.user.info.avatar = this.userInfo.avatar;
                    localStorage.setItem('USER', JSON.stringify(this.$store.state.admin.user.info));
                    this.$router.back();
                }).catch(err => {
                    Toast.fail(err.message);
                })
            },
            timestampToTime (timestamp) {
                var date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                const Y = date.getFullYear() + '-';
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                const D = date.getDate() + ' ';
                const h = date.getHours() + ':';
                const m = date.getMinutes() + ':';
                const s = date.getSeconds();
                return Y + M + D + h + m + s;
            },
            beforeRead (file) {
                if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                    Toast('只允许上传jpg/png格式的图片！')
                    return false;
                }
                return true
            },
            async afterRead (file) {
                // 此时可以自行将文件上传至服务器
                file.status = 'uploading';
                file.message = '上传中...';
                const fid = await uploadfilecommon(file.file, 'AVATAR')
                file.status = 'done';
                file.message = '上传成功';
                if (fid && fid.length === 32) {
                    this.userInfo.avatar = fid;
                    this.$store.state.admin.user.info.avatar = this.userInfo.avatar;
                }
            },
            beforeDel (file, detail) {
                Dialog.confirm({
                    title: '是否删除头像'
                }).then(() => {
                    $.delete('deleteFile/' + this.userInfo.avatar).then(res => {
                        this.userInfo.avatar = '';
                        this.avatar.splice(detail.index, 1);
                        $.put('user', this.userInfo);
                        Toast.success('删除成功！');
                        return true;
                    }).catch(err => {
                        Toast.fail(err.message);
                        return false;
                    });
                })
            }
        },
        mounted () {
            $.get('user/' + this.$store.state.admin.user.info.username).then(res => {
                this.userInfo = res;
                this.userInfo.createTime = this.timestampToTime(this.userInfo.createTime);
                this.userInfo.modifyTime = this.timestampToTime(this.userInfo.modifyTime);
                this.userInfo.lastLoginTime = this.timestampToTime(this.userInfo.lastLoginTime);
                if (this.userInfo.avatar) {
                    this.avatar[0] = { url: this.apiUrl + 'download/' + this.userInfo.avatar, isImage: true };
                }
            })
        }
    }
</script>

<style lang="less" scoped>
    .topDiv{
        margin-top:20px;
    }
    .lableTxt{
        height:80px;
        line-height:80px;
        font-size:28px;
        width:28%;
    }
    .starTxt{
        height:80px;
        line-height:80px;
        font-size:28px;
    }
    .starTxt span{
        color: #FF6969;
        font-size: 30px;
        margin-right: 3px;
    }

    .typeDiv{
        padding:20px 30px;
        font-size: 28px;
    }
    .typeRow{
        padding-left:20px;
        border-left:6px solid #50C9FF;
    }
    .typeRow .van-col:nth-child(2){
        font-size: 0.38rem;
        font-weight: 400;
    }
    .typeItem{
        box-shadow: #f2f3f5 0px 0px 20px 1px;
    }
    .type-search {
        background-color: #EBEEF5;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 2vw 4vw;
        border-radius: 50px;
        padding:0 0 0 4vw;
    }
    .type-search button{
        border-radius: 0 50px 50px 0;
    }
    .search-icon {
      margin-left: 5px;
      font-size: 50px;
    }
    .searchInput {
      margin: 0 1.5vw;
      background-color: #F7F8FA;
      border: 0px;
      font-size: 14px;
      flex: 1;
      background:none;
      padding:15px;
    }
    .clear-icon {
        color: #999;
        font-size: 40px;
        margin-right:15px;
    }
    .van-cell{
        font-size: 0.37rem;
    }
    .van-radio{
        color: #666666;
    }
    .headImg{
      width: 160px;
      height: 160px;
      display: none;
    }

</style>
